import styled from '@emotion/styled'

const StyledContent = styled.div`
  /*border: 16px solid #f3f3f3;*/
  border: 2px solid;
  border-color: ${(props) => {
    const { color } = props
    return color
  }};
  border-radius: 50%;
  border-top: 3px solid;
  border-top-color: ${(props) => {
    const { backgroundColor } = props
    if (backgroundColor) {
      return backgroundColor
    }
    return 'transparent'
  }};
  width: 32px;
  height: 32px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
export default StyledContent
